module.exports = __webpack_public_path__ + "static/media/Evil Robot.5b4132ac.jpg";